import React from "react";
import { Link } from "react-router-dom";
import { FaqAccordion } from "../shared/FaqAccordion";
import { SectionHeader } from "../shared/SectionHeader";

// [SEO/GEO] [Trust] Answer first, then the qualification. Ordered by persona priority. No invented policies.
const faqs = [{
  question: "We’re rightsizing. Are your designs suited to single-level living?",
  answer: "Yes. All four of our published designs are single-storey, with three or four bedrooms. Whether one suits you depends on your block and how you want to live, so we talk that through before you commit."
}, {
  question: "Can we knock down our current home and rebuild on the same block?",
  answer: "Yes. Knock-down/rebuilds are one of our core services, replacing your existing house with a modern home designed for the way you live today. Demolition, services and site conditions all affect the plan, so we look at your block early and explain what’s involved."
}, {
  question: "Can we build a new home on the rear of our block?",
  answer: "Yes, we build rear-block homes. Subdivision and planning approvals are separate processes, so we talk through how a rear-block build fits around them before anything is decided."
}, {
  question: "Who will we actually deal with?",
  answer: "The owners. Tommy and Justin stay involved, you have a consistent point of contact, and our small team carefully manages its workload so each home gets the attention it needs. You also work directly with our designers and build team from the very beginning."
}, {
  question: "How will we be kept informed during the build?",
  answer: "We keep you updated at every stage, with clear and honest updates from start to handover. We’ll agree at the start how you prefer to be contacted."
}, {
  question: "How much will our home cost?",
  answer: "It depends on the design, your site, your selections and the agreed scope. Rather than publish a headline figure that leaves out real costs, we work towards project-specific costing through the design and costing stage."
}, {
  question: "What’s included in the price?",
  answer: "Inclusions are set out in the schedule for your project. Items in photographs aren’t automatically standard, so ask for the current schedule and compare scope, exclusions and allowances."
}, {
  question: "How long does a build take?",
  answer: "It varies with the design, site, approvals, selections and scheduling. We discuss expected timing for your project rather than quote a generic figure."
}, {
  question: "Do you build investment properties and developments?",
  answer: "Yes. We build investment homes, duplexes and multi-unit projects, and we invest in our own developments, so we understand the decisions from an investor’s side."
}, {
  question: "What are the first steps?",
  answer: "Request a consultation. We’ll talk about your plans, your block and your priorities, then identify the best pathway for your project. The next stage is a pre-con agreement, which confirms the scope, design direction and applicable pre-construction costs before that work begins."
}];
export function FaqSection() {
  return <section id="faqs" aria-labelledby="faq-heading" className="bg-paper py-20 md:py-28" data-id="element-219" data-mp="1iqrjrw8mf7ir">
      <div className="mx-auto max-w-site px-5 md:px-10" data-id="element-220" data-mp="1no9m33s4uohs">
        <SectionHeader id="faq-heading" title="Questions before you build?" intro={<>
              Straight answers to what we’re asked most. Something else on your mind?{" "}
              <Link to="/contact" className="font-medium text-charcoal underline underline-offset-4" data-id="element-222" data-mp="21p3v9on08thi">Ask the owners.</Link>
            </>} data-id="element-221" data-mp="1nr5n50za1tag" />
        <div className="mx-auto mt-12 max-w-3xl" data-id="element-223" data-mp="26m44g8f5iccu">
          <FaqAccordion items={faqs} data-id="element-224" data-mp="2uczpmmp3q9b4" />
        </div>
      </div>
    </section>;
}